module.exports = __webpack_public_path__ + "static/banner-01-44d83fc938a20ae3d849413af16faa66.png";